
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class TravelAreaModalContent extends Vue {

	@Prop()
	travelArea: string[]

	checkedList = []

	onChange(checkedList) {
		this.$emit('selectedList', checkedList)
	}
}
